import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { getJoinedCount } from "../../../utility/httpActions/waitlistActions";
import { useFeatureFlag } from "../../../hooks/useFeatureFlags";
import { landingColors } from "../landingColors";
import AnimatedCount from "./AnimatedCount";

// Only worth showing once the number reads as real traction rather than a
// nearly-empty marketplace — see project discussion for why 100 was chosen.
const DISPLAY_THRESHOLD = 100;

const JoinedCounter = ({ sx }) => {
  const isEnabled = useFeatureFlag("landing-joined-count");
  const { data } = useQuery({
    queryKey: ["joinedCount"],
    queryFn: getJoinedCount,
    enabled: isEnabled,
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
  });

  if (!isEnabled || !data?.count || data.count < DISPLAY_THRESHOLD) return null;

  return (
    <Typography
      variant="body2"
      sx={{ color: landingColors.textSecondary, fontWeight: 600, ...sx }}
    >
      <Box
        component="span"
        sx={{
          display: "inline-block",
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: "#22c55e",
          mr: 1,
          verticalAlign: "middle",
        }}
      />
      <AnimatedCount value={data.count} /> people have joined Ngwaahia 🎉
    </Typography>
  );
};

export default JoinedCounter;
